import React, { useState } from "react";
import { Container } from "@material-ui/core";
import Layout from "../layout";
import BuildPage from "../build/buildPage";
import HomeHero from "../home-hero";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";

const PageBuild = (props) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const elementorData = props.data.modifiedData;
  return (
    <Layout openSearch={isSearchOpen}>
      {/* Home Hero */}
      {props.data.uri === "/" && <HomeHero />}
      {/* Build Elementor Data */}
      <BuildPage data={elementorData} />
    </Layout>
  );
};

export default PageBuild;
